import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css';

const mainNavLinks = [
  { path: '/', icon: 'fas fa-home' },
  { path: '/our-plant', icon: 'fas fa-seedling' },
  { path: '/love-letters', icon: 'fas fa-envelope' },
  { path: '/journal', icon: 'fas fa-book-open' },
];

const moreNavLinks = [
  { path: '/mood', icon: 'fas fa-smile', name: 'Mood' },
  { path: '/countdowns', icon: 'fas fa-clock', name: 'Countdowns' },
  { path: '/tinder', icon: 'fas fa-fire', name: 'Tinder' },
  { path: '/profile', icon: 'fas fa-user', name: 'Profile' },
  { path: '/dates', icon: 'fas fa-calendar-alt', name: 'Dates' },
];

const Navbar = ({ toggleTheme, currentTheme }) => {
  const [isMoreMenuVisible, setMoreMenuVisible] = useState(false);

  const handleMoreClick = () => {
    setMoreMenuVisible(!isMoreMenuVisible);
  };

  const closeMenu = () => {
    setMoreMenuVisible(false);
  };

  return (
    <>
      <div id="navbarContainer">
        <div id="menuWrapper">
          {mainNavLinks.map(link => (
            <NavLink 
              key={link.path} 
              to={link.path} 
              className={({ isActive }) => "menuElement" + (isActive ? " active" : "")}
              end // Important for home link to not stay active
            >
              <i className={link.icon}></i>
            </NavLink>
          ))}
          <button onClick={handleMoreClick} className="menuElement">
            <i className="fas fa-ellipsis-h"></i>
          </button>
        </div>
      </div>

      <div id="backdrop" className={isMoreMenuVisible ? 'visible' : ''} onClick={closeMenu}></div>
      
      <div id="moreMenuPanel" className={isMoreMenuVisible ? 'visible' : ''}>
        <div id="moreMenuGrid">
          {moreNavLinks.map(link => (
            <NavLink 
              key={link.path} 
              to={link.path} 
              className={({ isActive }) => "moreMenuElement" + (isActive ? " active" : "")}
              onClick={closeMenu}
            >
              <i className={link.icon}></i>
              <span>{link.name}</span>
            </NavLink>
          ))}
          <button onClick={() => { toggleTheme(); closeMenu(); }} className="moreMenuElement theme-toggle">
            <i className={currentTheme === 'light' ? 'fas fa-moon' : 'fas fa-sun'}></i>
            <span>Theme</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default Navbar;